import { Action, bindActionCreators, Dispatch } from "redux";
import AppContainer from "./App.container";
import { connect } from "react-redux";
import { getIsLoggedIn } from "../redux/authReducer/selectors";
import { IRootStore } from "../redux";
import { logOut } from "../redux/authReducer/actions";

const mapDispatchToProps = (dispatch: Dispatch<Action>) =>
  bindActionCreators({ logOut }, dispatch);

const mapStateToProps = (state: IRootStore) => ({
  isLoggedIn: getIsLoggedIn(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppContainer);
